import { useTranslation } from "@/features/utils/i18n";
import { PageLayout } from "../layout";
import { DeviceBaseDialogHost } from "./components/base-dialog";
import { DeviceBasesTable } from "./components/bases-table";
import { DevicesTable } from "./components/devices-table";

/**
 * VoIP handsets and the bases they run on — its own page under the "Canaux"
 * section rather than a block on the connectors page. A handset is telephony
 * hardware with its own lifecycle (credentials, registration, revocation); a
 * connector is an account with an operator. They belong to the same part of the
 * product and are not the same object.
 *
 * The two tables are on one page for the client and in two tabs for platform
 * staff, and both mount the same components: a client has a handful of phones
 * and reads them together, while staff arrive at a client with one question and
 * do not want the other table in the way.
 */
export function DevicesPage() {
  const { t } = useTranslation("devices");

  return (
    <PageLayout title={t("devices.title")} description={t("devices.description")}>
      <DevicesTable />
      <DeviceBasesTable />
      {/* Once for the page: both tables open a base. */}
      <DeviceBaseDialogHost />
    </PageLayout>
  );
}
